const API_URL = 'https://talku.online';

function getToken() {
  return localStorage.getItem('talku_token') || '';
}

function authHeaders(extra = {}) {
  return {
    'Authorization': `Bearer ${getToken()}`,
    ...extra,
  };
}

export const api = {
  // PEDIDOS
  getOrders: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const res = await fetch(`${API_URL}/orders/?${query}`, {
      headers: authHeaders(),
    });
    return res.json();
  },
  getOrderFulfillments: async (shopifyId) => {
    const res = await fetch(`${API_URL}/orders/${shopifyId}/fulfillments`, {
      headers: authHeaders(),
    });
    return res.json();
  },
  cancelOrder: async (shopifyId) => {
    const res = await fetch(`${API_URL}/orders/${shopifyId}/cancel`, {
      method: 'POST',
      headers: authHeaders(),
    });
    return res.json();
  },
  addTag: async (shopifyId, tag) => {
    const res = await fetch(`${API_URL}/orders/${shopifyId}/tags`, {
      method: 'POST',
      headers: authHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ tag }),
    });
    return res.json();
  },
  addNote: async (shopifyId, note) => {
    const res = await fetch(`${API_URL}/orders/${shopifyId}/note`, {
      method: 'POST',
      headers: authHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ note }),
    });
    return res.json();
  },
  getVariantImage: async (variantId) => {
    const res = await fetch(`${API_URL}/orders/variant-image/${variantId}`, {
      headers: authHeaders(),
    });
    return res.json();
  },
  getOrdersPorGenerar: async () => {
    const res = await fetch(`${API_URL}/orders/por-generar`, {
      headers: authHeaders(),
    });
    return res.json();
  },
  getAbandonedCheckouts: async (days = 5) => {
    const res = await fetch(`${API_URL}/orders/abandoned?days=${days}`, {
      headers: authHeaders(),
    });
    return res.json();
  },

  // CONTACTOS
  getContacts: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const res = await fetch(`${API_URL}/contacts/?${query}`, {
      headers: authHeaders(),
    });
    return res.json();
  },
  getContactOrders: async (customerId) => {
    const res = await fetch(`${API_URL}/contacts/${customerId}/orders`, {
      headers: authHeaders(),
    });
    return res.json();
  },
};
